export default "assets/images/icons/menu-arrow-a5742c55.svg";